module.exports = __webpack_public_path__ + "img/MWCfloor.d6edfb60.png";